export const APP_CONFIG = {
    whatsapp_ai_url: "https://waapi.bettercoffee.my.id",
    whatsapp_ai_subscription_url: "https://waapi.bettercoffee.my.id/subscription",
};
